import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import _ from "lodash";
import * as actions from "./actions";
import CustomShowModal from "../Common/customShowModal";
import Autocomplete from "@mui/lab/Autocomplete";
import { toastError, toastSuccess } from "../../utils";

export default function UserActions(props) {
  const [createUserData, setCreateUserData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    password: "",
  });

  const [openAddUser, setOpenAddUser] = useState(false);
  const [openViewUsers, setOpenViewUsers] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [allSubAdmins, setAllSubAdmins] = useState();
  const [allAssignedUsers, setAllAssignedUsers] = useState();
  const [nameOfAdminSelected, setNameOfAdminSelected] = useState("");
  const [selectedUser, setSelectedUser] = useState();
  const [selectedAdminId, setSelectedAdminId] = useState();
  const [searchedUsers, setSearchedUsers] = useState([]);

  const [filters, setFilters] = useState({
    search: "",
  });

  const delaySearch = useCallback(
    _.debounce((filters) => getUsersBySearching(filters), 500),
    []
  );

  const getUsersBySearching = (filters) => {
    props.setLoader(true);
    actions
      .searchUsersAdmin({ ...filters })
      .then((res) => {
        props.setLoader(false);
        setSearchedUsers(res.body);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err.message);
      });
  };

  const onChangeSearch = (value) => {
    const newFilters = { search: value };
    setFilters(newFilters);
    delaySearch(newFilters);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCreateUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onCreateUser = () => {
    if (
      !(
        createUserData.name &&
        createUserData.email &&
        createUserData.phone &&
        createUserData.address &&
        createUserData.password
      )
    ) {
      toastError("All fields are required");
      return;
    }
    props.setLoader(true);
    actions
      .addUserByAdmin({
        name: createUserData.name,
        email: createUserData.email,
        phone: createUserData.phone,
        address: createUserData.address,
        password: createUserData.password,
      })
      .then((res) => {
        toastSuccess(res.message || "Created successfully");
        setOpenAddUser(false);
        setCreateUserData({
          name: "",
          email: "",
          phone: "",
          address: "",
          password: "",
        });
        props.setLoader(false);
      })
      .catch((err) => {
        toastError(err.message);
        props.setLoader(false);
      });
  };

  const getAdmins = () => {
    props.setLoader(true);
    actions
      .getAllSubadminsAdmin()
      .then((res) => {
        props.setLoader(false);
        setAllSubAdmins(res.body);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err.message);
      });
  };

  const getSearchReleases = (subAdminId) => {
    props.setLoader(true);
    actions
      .getAllAssignedUsersForSubAdmin({ subAdminId: subAdminId })
      .then((res) => {
        props.setLoader(false);
        setAllAssignedUsers(res.body);
      })
      .catch((err) => {
        props.setLoader(false);
      });
  };

  const onViewUsersList = async (subAdminId) => {
    await getSearchReleases(subAdminId);
    setOpenViewUsers(true);
  };

  const onCloseViewList = () => {
    setAllAssignedUsers();
    setOpenViewUsers(false);
  };

  const onAssignUser = () => {
    if (!selectedUser) {
      toastError("Please select a user.");
      return;
    }
    props.setLoader(true);
    actions
      .giveUserAccessToAdmin({
        user_id: selectedUser.user_id,
        subAdminId: selectedAdminId,
      })
      .then((res) => {
        toastSuccess(res.message || "Created successfully");
        props.setLoader(false);
        setAssignModal(false);
        setSelectedAdminId();
        setSelectedUser();
      })
      .catch((err) => {
        toastError(err.message);
        props.setLoader(false);
      });
  };

  const onSetAssignModalOpen = async (subAdminId, name) => {
    setNameOfAdminSelected(name);
    setAssignModal(true);
    setSelectedAdminId(subAdminId);
  };

  useEffect(() => {
    getAdmins();
    getUsersBySearching(filters);
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            size="large"
            onClick={() => setOpenAddUser(true)}
          >
            Create User
          </Button>
        </div>

        <Box mt={2}>
          <p
            style={{
              fontWeight: 500,
              marginBottom: 15,
              fontSize: "25px",
            }}
          >
            List of all Sub-Admins
          </p>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Admin Id
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Admin Email
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Last Login
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Users Assigned
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    View Users
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Assign Users
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allSubAdmins?.map((user, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ fontSize: "14px" }}>
                      {user.subAdminId}
                    </TableCell>
                    <TableCell style={{ fontSize: "14px" }}>
                      {user.email}
                    </TableCell>
                    <TableCell style={{ fontSize: "14px" }}>
                      {user.lastLoginOn
                        ? new Date(Number(user.lastLoginOn)).toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })
                        : 'Never'}
                    </TableCell>
                    <TableCell style={{ fontSize: "14px" }}>
                      {user.numberOfUsersAssigned || 0}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="medium"
                        onClick={() => onViewUsersList(user.subAdminId)}
                      >
                        View Users
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        size="medium"
                        onClick={() =>
                          onSetAssignModalOpen(user.subAdminId, user.email)
                        }
                      >
                        Assign User
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>

      <CustomShowModal
        handleClose={() => setOpenAddUser(false)}
        title={"Add User Details"}
        open={openAddUser}
        maxWidth="sm"
      >
        <>
          <div style={{ textAlign: "center" }}>
            <Box mt={1}>
              <TextField
                label="User Name"
                name="name"
                variant="outlined"
                size="small"
                value={createUserData.name}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={1}>
              <TextField
                label="User Email"
                name="email"
                type="email"
                variant="outlined"
                size="small"
                value={createUserData.email}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={1}>
              <TextField
                label="Phone Number"
                name="phone"
                type="text"
                variant="outlined"
                size="small"
                value={createUserData.phone}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={1}>
              <TextField
                label="User Address"
                name="address"
                type="text"
                variant="outlined"
                size="small"
                value={createUserData.address}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={1}>
              <TextField
                label="Password"
                name="password"
                type="text"
                variant="outlined"
                size="small"
                value={createUserData.password}
                onChange={handleChange}
                fullWidth
              />
            </Box>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <Button color="primary" variant="contained" onClick={onCreateUser}>
              Create User
            </Button>
          </div>
        </>
      </CustomShowModal>

      <CustomShowModal
        handleClose={() => onCloseViewList()}
        title={"Users List"}
        open={openViewUsers}
        maxWidth="md"
      >
        <div style={{ textAlign: "center" }}>
          <TableContainer
            component={Paper}
            // style={{  marginLeft: 20 }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    User Id
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Name
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Email
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allAssignedUsers?.map((user, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ fontSize: "14px" }}>
                      {user.user_id}
                    </TableCell>
                    <TableCell style={{ fontSize: "14px" }}>
                      {user.name}
                    </TableCell>
                    <TableCell style={{ fontSize: "14px" }}>
                      {user.email}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomShowModal>

      <CustomShowModal
        handleClose={() => setAssignModal(false)}
        title={`Assign Users to ${nameOfAdminSelected}`}
        open={assignModal}
        maxWidth="sm"
      >
        <>
          <div style={{ textAlign: "center" }}>
            <Box>
              <Autocomplete
                options={searchedUsers}
                value={selectedUser}
                onChange={(event, newValue) => setSelectedUser(newValue)}
                onInputChange={(event, value) => onChangeSearch(value)}
                getOptionLabel={(option) => option?.email || ""}
                isOptionEqualToValue={(option, value) =>
                  option.user_id === value.user_id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Select User"
                    placeholder="Search user by email"
                  />
                )}
              />
            </Box>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <Button color="primary" variant="contained" onClick={onAssignUser}>
              Assign
            </Button>
          </div>
        </>
      </CustomShowModal>
    </>
  );
}
